import { requestConstantsMaker } from '../helper';

/**** 20200217 ****/
export const GET_ALL_STUDENT = requestConstantsMaker('GET_ALL_STUDENT');
export const GET_STUDENT = requestConstantsMaker('GET_STUDENT');
export const CREATE_STUDENT = requestConstantsMaker('CREATE_STUDENT');
export const UPDATE_STUDENT = requestConstantsMaker('UPDATE_STUDENT');
export const GET_STUDENTS_FOR_SELECTION = requestConstantsMaker('GET_STUDENTS_FOR_SELECTION');
export const GET_STUDENTS_FOR_CUSTOMER_DETAIL = requestConstantsMaker('GET_STUDENTS_FOR_CUSTOMER_DETAIL');
export const GET_ASQ_REMINDER_STUDENTS = requestConstantsMaker('GET_ASQ_REMINDER_STUDENTS');
/**** 20200217 ****/

export const GET_ALL_STUDENT_BY_SPECIFICATION = requestConstantsMaker('GET_ALL_STUDENT_BY_SPECIFICATION');
// export const GET_ALL_STUDENT = requestConstantsMaker('GET_ALL_STUDENT');
export const GET_STUDENT_BY_ID = requestConstantsMaker('GET_STUDENT_BY_ID');
export const POST_CREATE_STUDENT = requestConstantsMaker('POST_CREATE_STUDENT');
export const PUT_UPDATE_STUDENT = requestConstantsMaker('PUT_UPDATE_STUDENT');
export const GET_ALL_STUDENT_BY_CUSTOMER_ID = requestConstantsMaker('GET_ALL_STUDENT_BY_CUSTOMER_ID');
export const CHECK_STUDENT = requestConstantsMaker('CHECK_STUDENT');